export default "__VITE_ASSET__CgoJ3NYe__"